<template>
  <div class="fertilizerManagement-page" style="height:calc(100% - 100px;) !important;">
    <div class="all-content-container">
      <div class="content-title-container">
        <div class="content-title-top">
          <h3>水肥一体化</h3>
           <el-button type="primary" style="float:right" @click="canlan">返回</el-button>
        </div>
      </div>
      <div style=" height:90%;">
        <!-- 开始 -->
        <div class="fertilizer-content-container">
          <el-scrollbar style="height:100%;">
            <el-row :gutter="10" class="content_warpper">
            <el-col :span="8" v-for="(item,index) in list1" :key="index">
              <div class="grid-content bg-purple">
                <div class="fertilizer-content-title">
                  <h5>{{item.name}}</h5>
                  <span>{{item.alarmType}}</span>
                </div>
                <div class="fertilizer-status">
                  <div class="gg-status" v-for="(val,index) in item.imagesList" :key="index">
                    <div class="gg-top">
                      <div class="gg-img" :class="val.status==0?'bavkgroundColor':''">
                        <img :src="val.UrlImg" alt />
                      </div>
                      <p>{{val.title}}</p>
                    </div>
                    <div class="gg-bom" :class="val.status==0?'bavkgroundColor':''">{{val.content}}</div>
                  </div>
                </div>
                <div class="yxms">
                  <span>运行模式：</span>
                  <el-row class="btn-row">
                    <button
                      @click="statusShow(item.controlType,0,index,item,item.id)"
                      :class="item.controlType==0?'btnC':''"
                    >手动</button>
                    <button
                      @click="statusShow(item.controlType,1,index,item,item.id)"
                      :class="item.controlType==1?'btnC':''"
                      class="marginLr btnMar"
                    >定时</button>
                    <button
                      @click="statusShow(item.controlType,2,index,item,item.id)"
                      :class="item.controlType==2?'btnC':''"
                    >联动</button>
                  </el-row>
                </div>
                <div class="dqcl">
                  当前存量：
                  <span
                    v-for="(val1,index1) in item.proportionList"
                    :key="index1"
                  >{{val1.title}}&nbsp;{{val1.content}}ml</span>
                </div>
                <div class="nowStatus">
                  <div class="nowStatus-left">当前状态：</div>
                  <div class="nowStatus-right">
                    <!-- 联动数据 -->
                    <el-row v-if="item.controlType==2">
                      <el-col
                        :span="8"
                        v-for="(item1,index) in item.waterEquipmentList"
                        :key="index"
                        class="over_text1"
                      >
                        <span>{{item1.title}}</span>
                        <span>{{item1.content}}</span>
                      </el-col>
                    </el-row>
                    <!-- 定时数据 -->
                    <el-row v-if="item.controlType==1">
                      <el-col
                        :span="8"
                        v-for="(item1,index) in item.waterEquipmentList"
                        :key="index"
                        class="over_text1"
                      >
                        <span>{{item1.title}}</span>
                        <span>{{item1.content}}</span>
                      </el-col>
                    </el-row>
                    <!-- 手动数据 -->
                    <el-row v-if="item.controlType==0">
                      <el-col
                        :span="8"
                        v-for="(item1,index) in item.waterEquipmentList"
                        :key="index"
                        class="over_text1"
                      >
                        <span>{{item1.title}}</span>
                        <span>{{item1.content}}</span>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <!-- <div class="nowStatus" v-if="item.controlType==0">
              
                   
                </div>-->
                <div class="fertilizer-bottom-container">
                  <span
                    class="locationAddress_textOver"
                    :title="item.locationAddress"
                    v-if="item.controlType==0"
                  >
                    <i>
                      <img src="../../static/img/位置.png" alt />
                    </i>
                    {{item.locationAddress}}
                  </span>
                  <span
                    v-if="item.controlType!=0"
                    :title="item.locationAddress"
                    class="controlTypeStatua"
                  >
                    <i>
                      <img src="../../static/img/位置.png" alt />
                    </i>
                    {{item.locationAddress}}
                  </span>
                  <button
                    v-if="item.controlType==0"
                    @click="swithType(item.executionValue,1,item,item.id,item.attributeId)"
                    :class="item.executionValue==1? 'btnC1':''"
                    class="buttonOut1"
                  >开</button>
                  <button
                    v-if="item.controlType==0"
                    @click="swithType(item.executionValue,0,item,item.id,item.attributeId)"
                    :class="item.executionValue==0? 'btnC1':''"
                    class="buttonOut"
                  >关</button>

                  <button
                    v-if="item.controlType==0"
                    @click="swithType(item.executionValue,2,item,item.id,item.attributeId)"
                    :class="item.executionValue==2? 'btnC1':''"
                    class="buttonOut1"
                  >停</button>

                  <div class="eidt_dailog" v-if="item.controlType ==0">
                    <div @click="goiRrigationRecordManagement(item.id)">
                      <span class="link lineCoverage">灌溉记录></span>
                    </div>
                    <div>
                      <span
                        class="link over_text1"
                        v-if="item.controlType==2"
                        @click="DialogShow(2,item.id,item.attributeId,item.eid,item.actionId,item.controlType,item.name)"
                      >配比及执行动作></span>
                      <span
                        class="link over_text1"
                        v-else
                        @click="DialogShow(1,item.id,item.attributeId,item.eid,item.actionId,item.controlType,item.name)"
                      >配比及执行动作></span>
                    </div>
                  </div>
                  <div class="eidt_dailog_2" v-if="item.controlType !=0">
                    <div @click="goiRrigationRecordManagement(item.id)">
                      <span class="link lineCoverage">灌溉记录></span>
                    </div>
                    <div>
                      <span
                        class="link over_text1"
                        v-if="item.controlType==2"
                        @click="DialogShow(2,item.id,item.attributeId,item.eid,item.actionId,item.controlType,item.name,item.eid)"
                      >配比及执行动作></span>
                      <span
                        class="link over_text1"
                        v-else
                        @click="DialogShow(1,item.id,item.attributeId,item.eid,item.actionId,item.controlType,item.name,item.eid)"
                      >配比及执行动作></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="el-table__empty-block" v-if="noData">
                <span class="el-table__empty-text">暂无数据</span>
              </div>
            </el-col>

            <div></div>
            <div class="pagination-content-container content-container">
              <el-pagination
                background
                layout="prev, pager, next,jumper"
                class="pageTap"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
              ></el-pagination>
            </div>
          </el-row>
          </el-scrollbar>  
        </div>

        <!-- 结束 -->
      </div>
      <!-- // -->
    </div>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="780px"
      :before-close="handleClose"
    >
      <i class="icom_dailog icom_dailog_1">*</i>
      <h3>
        配比
        <img
          src="../../static/img/bianji.png"
          alt
          style="margin-left:5px;"
          @click="spanShow"
          class="pibiImg"
        />
      </h3>
      <el-form ref="form" :model="form" label-width="30px" class="sfjpb">
        <el-form-item class="peibi">
          <el-row>
            <el-col v-for="(item,index) in proportionList" :key="index" :span="4">
              <el-form-item :label="item.title">
                <span v-if="spanType==true">{{item.propor }}</span>
                <el-input v-else v-model="item.propor" maxlength="10" style="width:70px;"></el-input>ml
                <!-- <el-input></el-input> -->
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <div class="lgz">
          <h3>轮灌组</h3>
          <span @click="addRow" class="addLgz">
            <i class="el-icon-plus"></i>新增轮灌组
          </span>
        </div>
        <div class="tables-container">
          <el-table
            :data="irrigationList"
            style="width: 100%"
            :header-cell-style="{background:'#F4F5F7',padding:'4px 0!important'}"
          >
            <el-table-column label="轮灌组名称" width="200" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.dateType===false">{{scope.row.title}}</span>
                <el-input
                  v-else
                  v-model="scope.row.title"
                  class="inputCen"
                  placeholder="请输入轮灌组"
                  maxlength="20"
                  clearable
                  style="text-align: center;"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="区域" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.nameType==false">
                  <span>{{(scope.row.content?scope.row.content:[]).join(',')}}</span>
                </div>
                <el-cascader
                  v-else
                  v-model="scope.row.content"
                  collapse-tags
                  @change="changeTreeItem"
                  :options="departList"
                  :props="optionProps"
                  clearable
                  placeholder="请选择区域"
                ></el-cascader>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <span>
                  <img
                    src="../../static/img/bianji.png"
                    alt
                    style="margin-left:5px;cursor: pointer;"
                    @click="selectShow(scope.$index,)"
                  />
                </span>
                <span>
                  <img
                    src="../../static/img/delete.png"
                    alt
                    style="margin-left:5px;cursor: pointer;"
                    @click="deleteRow(scope.$index, irrigationList)"
                  />
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="controlType!='0'">
          <div class="cftjian">
            <h3>
              触发条件
              <img :src="imgUrl" alt style="margin-left:5px;cursor: pointer;" @click="showDia" />
            </h3>
            <div class="cfDiv" v-if="type==1">
              <span v-if="Diainput==false">{{toggleCondition}}</span>
              <!-- 定时数据 -->
              <el-form-item
                v-for="(domain22, index0) in timeList"
                :key="domain22.intervalPeriod"
                :prop="'timeList.' + index0 + '.value'"
                v-else
              >
                <el-row>
                  <el-col :span="9">
                    <el-form-item label="选择时段" label-width="63px" class="xzsd">
                      <el-time-picker
                        is-range
                        v-model="domain22.timer"
                        format="HH:mm"
                        value-format="HH:mm"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        placeholder="选择时间范围"
                      ></el-time-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="间隔周期" label-width="63px">
                      <el-input-number
                        :controls="false"
                        clearable
                        :max="99999"
                        style="width:80px"
                        v-model="domain22.intervalPeriod"
                        placeholder="间隔周期"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="持续时间" label-width="63px">
                      <!-- <el-input
                        v-model="domain22.durationTime"
                        placeholder="持续时间"
                        maxlength="20"
                        clearable
                      ></el-input>-->
                      <el-input-number
                        :controls="false"
                        clearable
                        :max="99999"
                        style="width:80px"
                        v-model="domain22.durationTime"
                        placeholder="持续时间"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="类型" label-width="35px">
                      <el-select v-model="domain22.timeType" placeholder="选择类型">
                        <el-option
                          :disabled="hide"
                          v-for="va in timeTypeList"
                          :key="va.id"
                          :label="va.name"
                          :value="va.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1">
                    <i class="el-icon-remove-outline" @click.prevent="removeDomain1(index0)"></i>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item>
                <el-link type="primary" @click="addDomain1" :underline="false">新增一行时段</el-link>
              </el-form-item>
            </div>
            <!-- 联动数据 -->
            <div class="LdcfDiv" v-else-if="type==2">
              <span v-if="Diainput==false">{{toggleCondition}}</span>
              <el-form-item
                v-for="(domain10, index1) in conditionList"
                :key="index1"
                :prop="'conditionList.' + index1 + '.value'"
                v-else
              >
                <el-row>
                  <el-col :span="5">
                    <el-form-item label="设备" label-width="34px">
                      <el-select v-model="domain10.eid" @change="change_val" placeholder="请选择设备">
                        <el-option
                          :disabled="hide"
                          v-for="item in sensorNameList"
                          :key="item.id"
                          @change="change_val"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="属性" label-width="50px">
                      <el-select v-model="domain10.attributeId" placeholder="请选择属性">
                        <el-option
                          :disabled="hide"
                          v-for="item in attributeLiST"
                          :key="item.id"
                          :label="item.cname"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="开始值" label-width="50px" class="seValue">
                      <el-input-number
                        style="width:100px"
                        v-model="domain10.startValue"
                        :max="99999999999"
                        :controls="false"
                        placeholder="开始值"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="结束值" label-width="50px" class="seValue">
                      <el-input-number
                        style="width:100px"
                        v-model="domain10.endValue"
                        :max="99999999999"
                        :controls="false"
                        placeholder="结束值"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1">
                    <i class="el-icon-remove-outline" @click.prevent="removeDomain(index1)"></i>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item>
                <el-link
                  type="primary"
                  @click="addDomain"
                  :underline="false"
                  v-if="Diainput==true"
                >新增一行时段</el-link>
              </el-form-item>
            </div>
          </div>
        </div>
        <el-form-item style="text-align:right;margin-right:0!important;margin-top:20px;">
          <el-button @click="dialogVisible = false;Diainput=false">取 消</el-button>
          <el-button type="primary" @click="svae()">确认</el-button>
          <!-- dialogVisible = false;Diainput=false -->
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "fertilizerManagement",
  data() {
    return {
      total: 0,
      pageSize: 3,
      currentPage: 1,
      noData: false,
      departList: [],
      optionProps: {
        value: "name",
        label: "name",
        children: "children",
        checkStrictly: true,
        multiple: true
      },
      title: "",
      current_show: "",
      hide: false,
      actionId: "",
      attributeId: "",
      controlType: "",
      eid: "",
      executionValue: "",
      id: "",
      imgUrl: require("@/static/img/bianji.png"),
      list1: [],
      dynamicValidateForm: {
        domains: [
          {
            value: ""
          }
        ],
        email: ""
      },
      dynamicValidateForm1: {
        domains: [
          {
            value: ""
          }
        ],
        email: ""
      },
      options: [],
      toggleCondition: "",
      irrigationList: [
        {
          attributeId: "",
          eid: "",
          id: "",
          title: "轮灌组1",
          content: ["区域1", "区域3"],
          dateType: false,
          nameType: false
        }
      ],
      timeTypeList: [
        {
          id: 0,
          name: "重复"
        },
        {
          id: 1,
          name: "一次"
        }
      ],
      proportionList: [
        {
          title: "氮",
          propor: " "
        },
        {
          title: "磷",
          propor: " "
        },
        {
          title: "钾",
          propor: " "
        },
        {
          title: "硫",
          propor: " "
        },
        {
          title: "钙",
          propor: " "
        },
        {
          title: "水",
          propor: ""
        }
      ],
      dialogVisible: false,
      pageNum: 1,
      pageSize: 3,

      ruleForm: {
        region: "",
        shebei: "",
        attribute: "",
        contTime: "",
        intervalTime: ""
      },
      Diainput: false,
      type: 2,
      spanType: true,
      form: {},
      value2: "",
      irrigationList: [
        {
          attributeId: "", //属性
          content: "", //
          eid: "", //设备
          id: "", //
          integratedGroupId: "",
          title: "", //
          type: ""
        }
      ],
      timeList: [
        {
          durationTime: "",
          endTime: "",
          id: "",
          intervalPeriod: "",
          linkageControlActionId: "",
          startTime: "",
          timeType: "",
          timer: ""
        }
      ],
      conditionList: [
        {
          attributeId: "",
          eid: "",
          endValue: "",
          id: "",
          linkageControlActionId: "",
          startValue: "",
          type: "2"
        }
      ],
      sensorNameList: [],
      attributeLiST: []
    };
  },
  created() {
    this.getConfigBaseEquipmentList(); //查询水肥一体化_水肥机列表
    this.getNumericals(); //  查询全部传感器
  },
  methods: {
    //分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getConfigBaseEquipmentList();
    },
    // 查询水肥一体化_水肥机列表
    getConfigBaseEquipmentList() {
      this.$api.system
        .getConfigBaseEquipmentList(
          this.currentPage, //第几页，默认1
          this.pageSize //默认展示多少条，默认10
        )
        .then(res => {
          if (res.code == 200) {
            this.total = res.count;
            var arr1 = [
              require("@/static/img/灌溉.png"),
              require("@/static/img/轮灌.png"),
              require("@/static/img/施肥.png"),
              require("@/static/img/过滤.png")
            ]; //固定图片
            for (let i = 0; i < res.data.length; i++) {
              for (let j = 0; j < res.data[i].imagesList.length; j++) {
                res.data[i].imagesList[j].UrlImg = arr1[j];
              }
            }
            this.list1 = res.data;
          }
        });
    },
    //  查询全部传感器
    getNumericals() {
      this.$api.system.getNumericals().then(res => {
        if (res.code == 200) {
          this.sensorNameList = res.data; //全部传感器
        }
      });
    },
    //  /查询全部属性名称
    getModelRuleAttributes(id) {
      this.$api.system.getModelRuleAttributes(id).then(res => {
        if (res.code == 200) {
          this.attributeLiST = res.data; //全部告警模板
        }
      });
    },
    change_val(val) {
      this.getModelRuleAttributes(val);
    },
    //保存
    svae() {
      //验证配比数据

      for (let i = 0; i < this.proportionList.length; i++) {
        if (!this.proportionList[i].propor) {
          return this.$toaster.warn("请输入配比值");
        }
      }
      //验证轮灌组数据
      for (let i = 0; i < this.irrigationList.length; i++) {
        if (
          !this.irrigationList[i].title ||
          this.irrigationList[i].title == ""
        ) {
          return this.$toaster.warn("请输入轮灌组名称");
        } else if (
          !this.irrigationList[i].content ||
          this.irrigationList[i].content == ""
        ) {
          return this.$toaster.warn("请选择区域");
        }
        this.irrigationList[i].content = this.irrigationList[
          i
        ].content.toString();
      }

      // this.irrigationList.forEach((val)=>{
      //   val.dateType=false
      // })
      //验证联动数据

      if (this.current_show == 2) {
        console.log("8888888");
        this.timeList = [];
        for (let i = 0; i < this.conditionList.length; i++) {
          if (!this.conditionList[i].eid || this.conditionList[i].eid == "") {
            return this.$toaster.warn("请选择设备");
          } else if (
            !this.conditionList[i].attributeId ||
            this.conditionList[i].attributeId == ""
          ) {
            return this.$toaster.warn("请选择属性");
          } else if (
            !this.conditionList[i].startValue ||
            this.conditionList[i].startValue == ""
          ) {
            return this.$toaster.warn("请输入开始值");
          } else if (
            !this.conditionList[i].endValue ||
            this.conditionList[i].endValue == ""
          ) {
            return this.$toaster.warn("请输入 结束值");
          }
        }
      } else {
        this.conditionList = [];
        //定时数据
        if (this.controlType != "0") {
          for (let i = 0; i < this.timeList.length; i++) {
            this.timeList[i].startTime = this.timeList[i].timer[0];
            this.timeList[i].endTime = this.timeList[i].timer[1];
          }
          for (let i = 0; i < this.timeList.length; i++) {
            if (
              !this.timeList[i].startTime ||
              this.timeList[i].startTime == ""
            ) {
              return this.$toaster.warn("请选择时段");
            } else if (
              !this.timeList[i].intervalPeriod ||
              this.timeList[i].intervalPeriod == ""
            ) {
              return this.$toaster.warn("请输入间隔周期");
            } else if (
              !this.timeList[i].durationTime ||
              this.timeList[i].durationTime == ""
            ) {
              return this.$toaster.warn("请输入持续时间");
            } else if (
              !this.timeList[i].timeType ||
              this.timeList[i].timeType == ""
            ) {
              // return this.$toaster.warn("请选择类型");
            }
          }
        }
      }
      console.log(this.eid);
      let obj = {};
      obj.id = this.id; // 主键id
      obj.actionId = this.actionId ? this.actionId : ""; //动作id
      obj.attributeId = this.attributeId; //属性id
      obj.eid = this.eid ? this.eid : ""; //设备id
      obj.executionValue = this.executionValue; //执行动作
      obj.controlType = this.controlType; //0 1 2 控制类型（0手动，1定时，2自动）
      obj.conditionList = this.conditionList; //联动数据
      obj.irrigationList = this.irrigationList; //轮灌组数据
      obj.proportionList = this.proportionList; //配比数据
      obj.timeList = this.timeList; //定时数据
      console.log(obj);

      this.saveConfigBaseEquipment(obj); //保存数据
    },
    // 保存水肥一体化_配比及执行动作
    saveConfigBaseEquipment(obj) {
      this.$api.system.saveConfigBaseEquipment(obj).then(res => {
        if (res.code == 200) {
          this.proportionList = [];
          this.irrigationList = [];
          this.conditionList = [];
          this.timeList = [];
          this.dialogVisible = false;
          this.getConfigBaseEquipmentList(); //查询水肥一体化_水肥机列表
          this.$toaster.ok(res.msg);
        } else {
          this.proportionList = [];
          this.irrigationList = [];
          this.conditionList = [];
          this.timeList = [];
          this.dialogVisible = false;
        }
      });
    },
    // 查询水肥一体化_配比及执行动作
    getConfigBaseEquipment(id) {
      this.$api.system.getConfigBaseEquipment(id).then(res => {
        if (res.code == 200) {
          this.toggleCondition = res.data.toggleCondition;
          this.conditionList = res.data.conditionList
            ? res.data.conditionList
            : [];
          this.irrigationList = res.data.irrigationList
            ? res.data.irrigationList
            : [];
          for (let i = 0; i < this.irrigationList.length; i++) {
            this.irrigationList[i].content = this.irrigationList[
              i
            ].content.split(",");
          }
          this.irrigationList.forEach(val => {
            // val.nameType=false;
            // val.dateType=false
          });
          this.proportionList = res.data.proportionList
            ? res.data.proportionList
            : [];
          this.conditionList = res.data.conditionList
            ? res.data.conditionList
            : [];
        }
      });
    },
    swithType(type, current, item, id, attributeId) {
      var _this = this;
      if (current == 0) {
        this.$confirm("是否关?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            item.executionValue = current;
            let data = new FormData();
            data.append("attributeId", attributeId);
            data.append("id", id);
            data.append("openValue", "");
            data.append("swtichStatus", current);
            _this.openOrCloseDeviceSwtich(data); //切换 接口
          })
          .catch(err => {
            console.log(err);
            this.$message({
              type: "info",
              message: "已取消关"
            });
          });
      } else if (current == 1) {
        this.$confirm("是否开?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            item.executionValue = current;
            item.executionValue = current;
            let data = new FormData();
            data.append("attributeId", attributeId);
            data.append("id", id);
            data.append("openValue", "");
            data.append("swtichStatus", current);
            _this.openOrCloseDeviceSwtich(data); //切换 接口
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消开"
            });
          });
      } else if (current == 2) {
        this.$confirm("是否停?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            item.executionValue = current;
            item.executionValue = current;
            let data = new FormData();
            data.append("attributeId", attributeId);
            data.append("id", id);
            data.append("openValue", "");
            data.append("swtichStatus", current);
            _this.openOrCloseDeviceSwtich(data); //切换 接口
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消停"
            });
          });
      }
    },

    goiRrigationRecordManagement(id) {
      this.$router.push({
        name: "irrigationRecordManagement",
        query: {
          id
        }
      });
    },
    // 按钮切换
    statusShow(controlType, current, index, row, id) {
      if (current == 0) {
        this.$confirm("是否切换到手动？", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let data = new FormData();
            data.append("controlType", current);
            data.append(" id", id);
            this.updateControlType(data);
            this.current_show = current;
            this.controlType = current;
            row.controlType = current;
          })
          .catch(() => {
            this.$message.info("已取消切换到手动");
          });
      } else if (current == 1) {
        this.$confirm("是否切换到定时？", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let data = new FormData();
            data.append("controlType", current);
            data.append(" id", id);
            this.updateControlType(data);
            this.current_show = current;
            this.controlType = current;
            row.controlType = current;
          })
          .catch(err => {
            console.log(err);
            this.$message.info("已取消切换到定时");
          });
      } else if (current == 2) {
        this.$confirm("是否切换到联动？", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let data = new FormData();
            data.append("controlType", current);
            data.append(" id", id);
            this.updateControlType(data);
            this.current_show = current;
            this.controlType = current;
            row.controlType = current;
          })
          .catch(() => {
            this.$message.info("已取消切换到联动");
          });
      }

      // this.controlType = eid;
      localStorage.setItem("controlType", current);
      this.id = "";
      //
      // this.getLinkageControlList()

      // this.list1[index].controlType=current;//切换按钮
    },
    handleClose() {
      this.dialogVisible = false;
      this.Diainput = false;
      this.spanType = true;
    },
    addRow() {
      var list = {
        attributeId: "",
        eid: "",
        id: "",
        title: "",
        content: "",
        dateType: true,
        nameType: true
      };
      this.irrigationList.push(list);
    },
    showDia() {
      this.Diainput = !this.Diainput;
      this.getLinkageControlInfoList(this.id); //查询定时条件、联动条件 (根据设备id)
      // this.$forceUpdate()
    },
    spanShow() {
      this.spanType = !this.spanType;
    },
    selectShow(row) {
      // row.nameType = !row.nameType;
      // row.dateType = !row.dateType;
      this.irrigationList[row].nameType = !this.irrigationList[row].nameType;
      this.irrigationList[row].dateType = !this.irrigationList[row].dateType;
    },
    removeDomain(index) {
      console.log(index);
      this.conditionList.splice(index, 1);
      // var index = this.dynamicValidateForm.domains.indexOf(item);
      // if (index !== -1) {
      //   this.dynamicValidateForm.domains.splice(index, 1);
      // }
    },
    removeDomain1(index) {
      this.timeList.splice(index, 1);
      // var index = this.dynamicValidateForm1.domains.indexOf(item);
      // if (index !== -1) {
      //   this.dynamicValidateForm1.domains.splice(index, 1);
      // }
    },
    addDomain() {
      this.conditionList.push({
        attributeId: "",
        eid: "",
        endValue: "",
        id: "",
        linkageControlActionId: "",
        startValue: "",
        type: ""
      });
    },
    addDomain1() {
      this.timeList.push({
        durationTime: "",
        endTime: "",
        id: "",
        intervalPeriod: "",
        linkageControlActionId: "",
        startTime: "",
        timeType: ""
      });
    },
    DialogShow(type, id, attributeId, eid, actionId, controlType, name) {
      this.title = name + "配比及执行动作";
      this.type = type;
      this.dialogVisible = true;
      this.id = id;
      this.attributeId = id;
      this.eid = eid;
      this.actionId = id;
      this.controlType = controlType;
      this.current_show = controlType;
      this.getConfigBaseEquipment(id); //询水肥一体化_配比及执行动作

      this.getConfigGroupTree(); //区域
    },
    spanShow1(id) {
      this.tableData[id].nameType = false;
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    selectDelete(id) {
      this.irrigationList.splice(id, 1);
    },
    // 水肥一体化手动、定时、联动类型切换
    updateControlType(obj) {
      this.$api.system.updateControlType(obj).then(res => {
        if (res.code == 200) {
          this.getConfigBaseEquipmentList(); // 列表接口
          this.$toaster.ok(res.msg);
        }
      });
    },
    // 开启或关闭开关设备
    openOrCloseDeviceSwtich(obj) {
      this.$api.system.openOrCloseDeviceSwtich(obj).then(res => {
        if (res.code == 200) {
          this.$toaster.ok(res.msg);
          this.getConfigBaseEquipmentList(); // 列表接口
        }
      });
    },

    //触发条件（获取数据）（详情）（查询定时条件、联动条件 (根据设备id)（ 调用智能控制接口）
    getLinkageControlInfoList(id) {
      this.$api.system.getToggleCondition(id).then(res => {
        if (res.code == 200) {
          this.conditionList = res.data.conditionList
            ? res.data.conditionList
            : [];
          this.timeList = res.data.timeList ? res.data.timeList : [];
          // this.showDia()
          this.timeList.forEach(val => {
            var timer = [];
            timer.push(val.startTime);
            timer.push(val.endTime);

            val.timer = timer;
          });
        }
      });
    },
    canlan(){
      history.go(-1)
    },
    //查询设备分组树，查询1
    getConfigGroupTree() {
      this.$api.system
        .getConfigGroupTree(
          0, //主键id ，根据具体业务进行判定
        )
        .then(res => {
          if (res.code == 200) {
            //二级
            res.data.forEach(val => {
              if(val.children){
                  val.children.forEach(value => {
                value.children = "";
              });
              }
              
            });
            this.departList = res.data;
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },

    //changeTreeItem
    changeTreeItem() {}
  }
};
</script>
<style lang="scss" scoped>
@import "@/style/fertilizerManagement.scss";
li {
  padding-left: 15px;
}
</style>